import React from 'react'
import classNames from 'classnames'

export default function Tile({
    children,
    component,
    onClick,
    borderColor,
    dashed,
    href,
    bgColor,
    className = ""
}) {

    const Component = component || "div"

    let classes = typeof className === "string" ? className.split(" ").reduce((acc, item) => {
        acc[item] = true
        return acc
    }, {}) : className;

    const Classes = classNames({
        "block w-full border rounded-xl overflow-hidden": true,
        "border-dashed": dashed,
        'cursor-pointer hover:border-primary': onClick || href,
        [`bg-${bgColor}`]: bgColor,
        'border-green': borderColor === 'green',
        'border-red': borderColor === 'red',
        'border-yellow': borderColor === 'yellow',
        'border-primary': borderColor === 'blue',
        'border-white': borderColor === 'dark',
        'border-transparent': borderColor === 'transparent',
        'border-lightprimary': borderColor === 'lightprimary',
        'border-line': !borderColor,
        ...classes

    })

    return (
        <Component className={Classes} href={href} onClick={onClick}>{children}</Component>
    )
}
